export default "__VITE_ASSET__CNRgIjl2__"